import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const SearchForm = ({ pathname, searchTerm, placeHolder }) => {
  const [search, setSearch] = useState(searchTerm ? searchTerm : '')
  const navigate = useNavigate()

  const handleSearch = (e) => {
    e.preventDefault()

    search.trim() == "" ? navigate(`${pathname}`) : navigate(`${pathname}?search=${encodeURIComponent(search)}`)
  }

  const onChangeSearchTerm = (e) => {
    let value = e.target.value
    setSearch(value)
  }

  return (
    <div>
      <form className='input-group input-group-sm' onSubmit={handleSearch}>
        <input className='form-control' placeholder={placeHolder} value={search} onChange={onChangeSearchTerm} />
        <button className='btn btn-secondary'>검색</button>
      </form>
    </div>
  )
};